/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetEmployeeDto } from './GetEmployeeDto';
import {
    GetEmployeeDtoFromJSON,
    GetEmployeeDtoFromJSONTyped,
    GetEmployeeDtoToJSON,
} from './GetEmployeeDto';

/**
 * 
 * @export
 * @interface GetMemoDto
 */
export interface GetMemoDto {
    /**
     * 
     * @type {string}
     * @memberof GetMemoDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetMemoDto
     */
    threadId: string;
    /**
     * 
     * @type {GetEmployeeDto}
     * @memberof GetMemoDto
     */
    sender: GetEmployeeDto;
    /**
     * 
     * @type {GetEmployeeDto}
     * @memberof GetMemoDto
     */
    recipient: GetEmployeeDto;
    /**
     * 
     * @type {object}
     * @memberof GetMemoDto
     */
    subject: object;
    /**
     * 
     * @type {Date}
     * @memberof GetMemoDto
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof GetMemoDto
     */
    content: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetMemoDto
     */
    unread: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMemoDto
     */
    sent: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMemoDto
     */
    first: boolean;
}

/**
 * Check if a given object implements the GetMemoDto interface.
 */
export function instanceOfGetMemoDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "threadId" in value;
    isInstance = isInstance && "sender" in value;
    isInstance = isInstance && "recipient" in value;
    isInstance = isInstance && "subject" in value;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "content" in value;
    isInstance = isInstance && "unread" in value;
    isInstance = isInstance && "sent" in value;
    isInstance = isInstance && "first" in value;

    return isInstance;
}

export function GetMemoDtoFromJSON(json: any): GetMemoDto {
    return GetMemoDtoFromJSONTyped(json, false);
}

export function GetMemoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMemoDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'threadId': json['threadId'],
        'sender': GetEmployeeDtoFromJSON(json['sender']),
        'recipient': GetEmployeeDtoFromJSON(json['recipient']),
        'subject': json['subject'],
        'date': (new Date(json['date'])),
        'content': json['content'],
        'unread': json['unread'],
        'sent': json['sent'],
        'first': json['first'],
    };
}

export function GetMemoDtoToJSON(value?: GetMemoDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'threadId': value.threadId,
        'sender': GetEmployeeDtoToJSON(value.sender),
        'recipient': GetEmployeeDtoToJSON(value.recipient),
        'subject': value.subject,
        'date': (value.date.toISOString()),
        'content': value.content,
        'unread': value.unread,
        'sent': value.sent,
        'first': value.first,
    };
}

